import React, { useCallback, useEffect, useState } from 'react';
import { Mail, Phone, Trash2, RefreshCw, Search } from 'lucide-react';
import api from '../../lib/api';

const STATUSES = ['new', 'in_progress', 'replied', 'archived'];

export default function Enquiries() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [q, setQ] = useState('');
  const [expanded, setExpanded] = useState(null);

  const load = useCallback(async () => {
    setLoading(true);
    try { const { data } = await api.get('/enquiries'); setItems(data); }
    finally { setLoading(false); }
  }, []);
  useEffect(() => { load(); }, [load]);

  const update = async (id, patch) => { await api.patch(`/enquiries/${id}`, patch); load(); };
  const remove = async (id) => { if (!window.confirm('Delete this enquiry?')) return; await api.delete(`/enquiries/${id}`); load(); };

  const filtered = items.filter((i) => `${i.name} ${i.email} ${i.message} ${i.service}`.toLowerCase().includes(q.toLowerCase()));

  return (
    <div>
      <div className="flex items-center justify-between flex-wrap gap-3 mb-6">
        <div>
          <h1 className="font-serif text-cream-50 text-3xl">Enquiries</h1>
          <p className="text-cream-100/60 text-sm mt-1">{items.length} total - newest first</p>
        </div>
        <div className="flex gap-3">
          <div className="relative">
            <Search className="h-4 w-4 text-cream-100/50 absolute left-3 top-1/2 -translate-y-1/2" />
            <input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Search…" className="bg-forest-900 border border-forest-800 pl-9 pr-3 py-2 text-sm text-cream-50 focus:border-sage-500 outline-none" />
          </div>
          <button onClick={load} className="inline-flex items-center gap-2 border border-forest-700 text-cream-100/85 px-4 py-2 text-sm hover:border-sage-500"><RefreshCw className="h-4 w-4" /> Refresh</button>
        </div>
      </div>

      {loading ? <p className="text-cream-100/60">Loading…</p> : (
        <div className="bg-forest-900 border border-forest-800">
          <table className="w-full text-sm">
            <thead>
              <tr className="text-left text-cream-100/50 border-b border-forest-800">
                <th className="p-3 font-normal uppercase tracking-widest text-[11px]">Date</th>
                <th className="p-3 font-normal uppercase tracking-widest text-[11px]">Name</th>
                <th className="p-3 font-normal uppercase tracking-widest text-[11px]">Service</th>
                <th className="p-3 font-normal uppercase tracking-widest text-[11px]">Status</th>
                <th className="p-3 font-normal uppercase tracking-widest text-[11px]">Actions</th>
              </tr>
            </thead>
            <tbody>
              {filtered.length === 0 && <tr><td colSpan={5} className="p-6 text-center text-cream-100/50">No enquiries yet.</td></tr>}
              {filtered.map((e) => (
                <React.Fragment key={e.id}>
                  <tr className="border-b border-forest-800/70 hover:bg-forest-800/40 cursor-pointer" onClick={() => setExpanded(expanded === e.id ? null : e.id)}>
                    <td className="p-3 text-cream-100/70">{new Date(e.created_at).toLocaleString('en-GB')}</td>
                    <td className="p-3 text-cream-50">{e.name}<div className="text-xs text-cream-100/60">{e.email}</div></td>
                    <td className="p-3 text-cream-100/75">{e.service}</td>
                    <td className="p-3">
                      <select value={e.status || 'new'} onClick={(ev) => ev.stopPropagation()} onChange={(ev) => update(e.id, { status: ev.target.value })} className="bg-forest-950 border border-forest-700 text-cream-50 text-xs px-2 py-1">
                        {STATUSES.map((s) => <option key={s} value={s}>{s.replace('_', ' ')}</option>)}
                      </select>
                    </td>
                    <td className="p-3">
                      <div className="flex gap-2" onClick={(ev) => ev.stopPropagation()}>
                        <a href={`mailto:${e.email}?subject=Re:%20${encodeURIComponent(e.service)}`} className="text-sage-400 hover:underline inline-flex items-center gap-1"><Mail className="h-3.5 w-3.5" /> Reply</a>
                        <button onClick={() => remove(e.id)} className="text-red-400 hover:underline inline-flex items-center gap-1"><Trash2 className="h-3.5 w-3.5" /> Delete</button>
                      </div>
                    </td>
                  </tr>
                  {expanded === e.id && (
                    <tr className="bg-forest-950">
                      <td colSpan={5} className="p-5">
                        <div className="grid md:grid-cols-2 gap-6">
                          <div>
                            <p className="text-xs uppercase tracking-widest text-cream-100/50 mb-2">Message</p>
                            <p className="text-cream-100/85 whitespace-pre-wrap">{e.message}</p>
                          </div>
                          <div className="text-sm space-y-2">
                            <p className="text-cream-100/70"><Phone className="inline h-4 w-4 mr-2 text-sage-400" />{e.phone || '-'}</p>
                            <p className="text-cream-100/70">Client type: {e.client_type}</p>
                            <p className="text-cream-100/50 text-xs">IP: {e.ip}</p>
                          </div>
                        </div>
                      </td>
                    </tr>
                  )}
                </React.Fragment>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
